import React from "react";
import { useSelector } from "react-redux";
import { selectAllFormSettings } from "../../../redux/slices/formSettingsSlice";
import { selectIsSinglePageForm } from "../../../redux/slices/appSettingsSlice";
import PaymentContentControl from "./PaymentContentControl";

/**
 * @param {object} props
 * @param {number} props.controlId
 * @returns {React.ReactElement}
 */
const ConnectedPaymentContentControl = ({ controlId }) => {
    const { captcha } = useSelector(selectAllFormSettings);
    const isSinglePageForm = useSelector(selectIsSinglePageForm);
    const displayTotalGift = !isSinglePageForm;

    return (
        <PaymentContentControl
            controlId={controlId}
            displayCaptcha={captcha}
            displayTotalGift={displayTotalGift}
        />
    );
};

export default ConnectedPaymentContentControl;
